module.exports = __webpack_public_path__ + "img/the witch summit.db19db78.png";